function formatPercentage(ratio) {
  return `${Math.floor(ratio * 100)}%`;
}

export default formatPercentage;
